"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withUiProps = exports.useClassNames = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /* eslint-disable import/prefer-default-export */
const useClassNames = _ref => {
  let {
    textColor,
    textLight,
    textDark,
    backgroundColor,
    backgroundLight,
    backgroundDark,
    color,
    light,
    dark,
    inverted,
    m,
    mx,
    my,
    mt,
    mr,
    mb,
    ml,
    p,
    px,
    py,
    pt,
    pr,
    pb,
    pl,
    textSize,
    textSizeMobile,
    textSizeTouch,
    textSizeTablet,
    textSizeDesktop,
    textSizeWidescreen,
    textSizeFullhd,
    textAlign,
    textAlignMobile,
    textAlignTouch,
    textAlignTablet,
    textAlignDesktop,
    textAlignWidescreen,
    textAlignFullhd,
    textTransform,
    textWeight,
    textFontFamily,
    display,
    displayMobile,
    displayTabletOnly,
    displayDesktopOnly,
    displayWidescreenOnly,
    displayTouch,
    displayTablet,
    displayDesktop,
    displayWidescreen,
    displayFullhd,
    isHidden,
    isHiddenMobile,
    isHiddenTabletOnly,
    isHiddenDesktopOnly,
    isHiddenWidescreenOnly,
    isHiddenTouch,
    isHiddenTablet,
    isHiddenDesktop,
    isHiddenWidescreen,
    isHiddenFullhd,
    isInvisible,
    isScreenReaderOnly,
    isFlex,
    isFlexResponsive,
    flexDirection,
    flexWrap,
    flexJustifyContent,
    flexAlignContent,
    flexAlignItems,
    flexAlignSelf,
    flexGrow,
    flexShrink,
    isClearFix,
    isPulledLeft,
    isPulledRight,
    isOverlay,
    isClipped,
    isRadiusless,
    isShadowless,
    isUnselectable,
    isClickable,
    isRelative,
    isFlexFullWidth,
    isFullHeight
  } = _ref;
  let textColorClassName = textColor ? `has-text-${textColor}` : null;
  if (textColor && textLight) {
    textColorClassName = `has-text-${textColor}-light`;
  }
  if (textColor && textDark) {
    textColorClassName = `has-text-${textColor}-dark`;
  }
  let backgroundColorClassName = backgroundColor ? `has-background-${backgroundColor}` : null;
  if (backgroundColor && backgroundLight) {
    backgroundColorClassName = `has-background-${backgroundColor}-light`;
  }
  if (backgroundColor && backgroundDark) {
    backgroundColorClassName = `has-background-${backgroundColor}-dark`;
  }
  return (0, _classnames.default)({
    // Color
    [textColorClassName]: textColorClassName,
    [backgroundColorClassName]: backgroundColorClassName,
    [`is-${color}`]: color,
    'is-light': light,
    'is-dark': dark,
    'is-inverted': inverted,
    // Spacing
    [`m-${m}`]: typeof m !== 'undefined',
    [`mx-${mx}`]: typeof mx !== 'undefined',
    [`my-${my}`]: typeof my !== 'undefined',
    [`mt-${mt}`]: typeof mt !== 'undefined',
    [`mr-${mr}`]: typeof mr !== 'undefined',
    [`mb-${mb}`]: typeof mb !== 'undefined',
    [`ml-${ml}`]: typeof ml !== 'undefined',
    [`p-${p}`]: typeof p !== 'undefined',
    [`px-${px}`]: typeof px !== 'undefined',
    [`py-${py}`]: typeof py !== 'undefined',
    [`pt-${pt}`]: typeof pt !== 'undefined',
    [`pr-${pr}`]: typeof pr !== 'undefined',
    [`pb-${pb}`]: typeof pb !== 'undefined',
    [`pl-${pl}`]: typeof pl !== 'undefined',
    // Typography
    [`is-size-${textSize}`]: textSize,
    [`is-size-${textSizeMobile}-mobile`]: textSizeMobile,
    [`is-size-${textSizeTouch}-touch`]: textSizeTouch,
    [`is-size-${textSizeTablet}-tablet`]: textSizeTablet,
    [`is-size-${textSizeDesktop}-desktop`]: textSizeDesktop,
    [`is-size-${textSizeWidescreen}-widescreen`]: textSizeWidescreen,
    [`is-size-${textSizeFullhd}-fullhd`]: textSizeFullhd,
    [`has-text-${textAlign}`]: textAlign,
    [`has-text-${textAlignMobile}-mobile`]: textAlignMobile,
    [`has-text-${textAlignTouch}-touch`]: textAlignTouch,
    [`has-text-${textAlignTablet}-tablet`]: textAlignTablet,
    [`has-text-${textAlignDesktop}-desktop`]: textAlignDesktop,
    [`has-text-${textAlignWidescreen}-widescreen`]: textAlignWidescreen,
    [`has-text-${textAlignFullhd}-fullhd`]: textAlignFullhd,
    [`is-${textTransform}`]: textTransform,
    [`has-text-weight-${textWeight}`]: textWeight,
    [`is-family-${textFontFamily}`]: textFontFamily,
    // Visibility::Show
    [`is-${display}`]: display,
    [`is-${displayMobile}-mobile`]: displayMobile,
    [`is-${displayTabletOnly}-tablet-only`]: displayTabletOnly,
    [`is-${displayDesktopOnly}-desktop-only`]: displayDesktopOnly,
    [`is-${displayWidescreenOnly}-widescreen-only`]: displayWidescreenOnly,
    [`is-${displayTouch}-touch`]: displayTouch,
    [`is-${displayTablet}-tablet`]: displayTablet,
    [`is-${displayDesktop}-desktop`]: displayDesktop,
    [`is-${displayWidescreen}-widescreen`]: displayWidescreen,
    [`is-${displayFullhd}-fullhd`]: displayFullhd,
    // Visibility::Hide
    'is-hidden': isHidden,
    'is-hidden-mobile': isHiddenMobile,
    'is-hidden-tablet-only': isHiddenTabletOnly,
    'is-hidden-desktop-only': isHiddenDesktopOnly,
    'is-hidden-widescreen-only': isHiddenWidescreenOnly,
    'is-hidden-touch': isHiddenTouch,
    'is-hidden-tablet': isHiddenTablet,
    'is-hidden-desktop': isHiddenDesktop,
    'is-hidden-widescreen': isHiddenWidescreen,
    'is-hidden-fullhd': isHiddenFullhd,
    'is-invisible': isInvisible,
    'is-sr-only': isScreenReaderOnly,
    // Flexbox
    'is-flex': isFlex,
    [`is-flex-direction-${flexDirection}`]: flexDirection,
    [`is-flex-wrap-${flexWrap}`]: flexWrap,
    [`is-justify-content-${flexJustifyContent}`]: flexJustifyContent,
    [`is-align-content-${flexAlignContent}`]: flexAlignContent,
    [`is-align-items-${flexAlignItems}`]: flexAlignItems,
    [`is-align-self-${flexAlignSelf}`]: flexAlignSelf,
    [`is-flex-grow-${flexGrow}`]: flexGrow,
    [`is-flex-shrink-${flexShrink}`]: flexShrink,
    'is-flex-grow-1 is-flex-shrink-1': isFlexFullWidth,
    'is-flex-responsive': isFlexResponsive,
    // Other
    'is-clearfix': isClearFix,
    'is-pulled-left': isPulledLeft,
    'is-pulled-right': isPulledRight,
    'is-overlay': isOverlay,
    'is-clipped': isClipped,
    'is-radiusless': isRadiusless,
    'is-shadowless': isShadowless,
    'is-unselectable': isUnselectable,
    'is-clickable': isClickable,
    'is-relative': isRelative,
    'is-fullheight': isFullHeight
  });
};
exports.useClassNames = useClassNames;
const withUiProps = Component => {
  const Wrapper = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
    const coreClassNames = useClassNames(props);
    const classNames = (0, _classnames.default)(props.className, coreClassNames);
    return /*#__PURE__*/_react.default.createElement(Component, _extends({
      ref: ref,
      className: classNames
    }, props));
  });
  Wrapper.displayName = 'withUiProps';
  Wrapper.propTypes = {
    className: _propTypes.default.string
  };
  return Wrapper;
};
exports.withUiProps = withUiProps;
//# sourceMappingURL=CoreProps.js.map